import { createRouter, createWebHistory } from "vue-router";

// Layouts
import HomeLayout from "@/layouts/HomeLayout.vue";

// Views
import HomePage from "@/views/HomePage.vue";
import AboutPage from "@/views/AboutPage.vue";
import ServicePage from "@/views/ServicePage.vue";
import PricingPage from "@/views/PricingPage.vue";
import ProjectPage from "@/views/ProjectPage.vue";

const routes = [
  {
    path: "/",
    component: HomeLayout,
    redirect: "/home",
    children: [
      {
        path: "home",
        name: "Home",
        component: HomePage,
        meta: { title: "Home" },
      },
      {
        path: "about",
        name: "About",
        component: AboutPage,
        meta: { title: "About" },
      },
      {
        path: "services",
        name: "Service",
        component: ServicePage,
        meta: { title: "Services" },
      },
      {
        path: "pricing",
        name: "Pricing",
        component: PricingPage,
        meta: { title: "Pricing" },
      },
      {
        path: "projects",
        name: "Project",
        component: ProjectPage,
        meta: { title: "Projects" },
      }
    ],
  },
];

const router = createRouter({
  history: createWebHistory("/"),
  routes,
  scrollBehavior() {
    return { top: 0 }; // auto-scroll to top on route change
  },
});

router.beforeEach((to) => {
  const title = to.meta.title || "AlgoPilot";
  document.title = `AlgoPilot | ${title}`;
});

export default router;
